<template>
  <SideBar />
 <div class="p-4 sm:ml-64 min-h-screen bg-gray-900 text-white">
  
   <GastoForm />
   <!-- Aquí se renderiza el componente -->
 </div>
</template>


<script>
import GastoForm from "../components/GastoForm.vue";
import SideBar from "../components/NavBar.vue";

export default {
  name: "NewVentaPage",
  components: {
    GastoForm,
    SideBar, // Register the imported component here
  },
};
</script>
